import { BrowserRouter, Route, Routes as RouterRoutes, useLocation } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { LanguageProvider } from "@/hooks/useLanguage";
import MainRoutes from "./Routes";  // Renamed to avoid confusion
import { CookieConsent } from "@/components/CookieConsent";
import { EnvInfo } from "@/components/EnvInfo";  // Import EnvInfo component
import { useEffect, useState } from "react";
import "./App.css";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

const queryClient = new QueryClient();

// Component to handle cookie consent logic based on route
const ConsentWrapper = ({ children }) => {
  const location = useLocation();
  const [showConsent, setShowConsent] = useState(true);
  
  useEffect(() => {
    // Check if user has already consented
    const hasConsented = localStorage.getItem("cookieConsent") === "true";
    const hasTempConsent = localStorage.getItem("temporaryCookieConsent") === "true";
    
    // Don't show consent on privacy/terms pages or if the user already consented
    const isPrivacyOrTermsPage = 
      location.pathname === "/privacy-policy" || 
      location.pathname === "/terms-of-service";
    
    setShowConsent(!hasConsented && !isPrivacyOrTermsPage);
    
    // Clean up temporary consent when navigating away from privacy/terms
    if (!isPrivacyOrTermsPage && hasTempConsent) {
      localStorage.removeItem("temporaryCookieConsent");
    }
  }, [location]);
  
  return (
    <>
      {children}
      {showConsent && <CookieConsent />}
    </>
  );
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <BrowserRouter>
          <ConsentWrapper>
            <RouterRoutes>
              {/* Use a catch-all route for main routes */}
              <Route path="/*" element={<MainRoutes />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
            </RouterRoutes>
            <Toaster />
            {/* Only show EnvInfo in development mode */}
            {import.meta.env.DEV && <EnvInfo />}
          </ConsentWrapper>
        </BrowserRouter>
      </LanguageProvider>
    </QueryClientProvider>
  );
}

export default App;